var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.test))]),_c('div',[_c('button',{staticStyle:{"background":"#888888"},on:{"click":function($event){return _vm.inicisTest()}}},[_c('p',[_vm._v("이니시스 테스트모드")])])]),_c('InicisComponent',{ref:"openPopup",on:{"electronicSignatureComplete":function($event){return _vm.requestConsentAgreement()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }